<div id="skip_anchor" class="content wideWd">
  <div class="content_title brd edit">
      <h2>{{contentMaster.contentMasterName}} 상세 <span class="template_url">content-detail</span></h2>
      <div class="content_title_sub" *ngIf="(isEditable && masterId != 'QNA') || isDeletable">
          <button type="button" (click)="removeContent()" class="btn_item btn_item-mid min-88 btn-danger-line">삭제하기</button>
      </div>
  </div>

  <div class="scroll-y">
      <div class="table-col">
          <dl class="table">
              <div class="tb_tr" *ngIf="masterId != 'QNA'">
                  <ng-container *ngIf="isEditable">
                      <dt>공개여부</dt>
                      <dd>
                          <div class="form_toggle">
                              <input type="checkbox" id="openYn" [disabled]="!isEditable" class="blind" [(ngModel)]="content.isOpen" (change)="changeStatus()"/>
                              <label for="openYn"><span class="blind">공개하기</span></label>
                          </div>
                      </dd>
                  </ng-container>
                  <ng-container *ngIf="!isEditable">
                      <dt>카테고리</dt>
                      <dd>{{content.contentCategoryName}}</dd>
                  </ng-container>
                  <dt>등록일</dt>
                  <dd>{{content.regDate | defaultDate}}</dd>
                  <dt>조회수</dt>
                  <dd>{{content.readCount | number}}</dd>
              </div>
              <div class="tb_tr" *ngIf="isEditable">
                  <dt>작성자</dt>
                  <dd>{{content.userId}} ({{content.userName}})</dd>
                  <dt>연락처</dt>
                  <dd>{{content.tel | tel}}</dd>
                  <dt>이메일</dt>
                  <dd>{{content.email}}</dd>
              </div>
              <div class="tb_tr" *ngIf="masterId == 'QNA'">
                  <dt>등록일</dt>
                  <dd>{{content.regDate | defaultDate}}</dd>
              </div>
              <div class="tb_tr">
                  <dt>첨부파일</dt>
                  <dd *ngIf="!isEditable">
                      <div class="attachFile" *ngFor="let item of content.files">
                          <a href="{{item.filePath}}" target="_blank" class="col-green">{{item.originFileNm}}</a>
                      </div>
                  </dd>
                  <dd *ngIf="isEditable">
                      <div class="attachFile">
                          <input type="file" id="attachFiles" #attachFiles (change)="onAttachFileChange(attachFiles.files, $event.target)" class="blind" />
                          <label for="attachFiles" class="badge_item badge_item-min badge_item-g1">등록하기</label>
                      </div>
                      <div class="attachFile" *ngFor="let item of content.files">
                          <a href="{{item.filePath}}" target="_blank" class="col-green">{{item.originFileNm}}</a>&nbsp;&nbsp;
                          <button type="button" class="badge_item badge_item-min badge_item-g1" (click)="deleteAttachedFile(item)">삭제하기</button>
                      </div>
                      <div class="attachFile" *ngFor="let item of attachFileList">
                          <span class="col-green">{{item.name}}</span>&nbsp;&nbsp;
                          <button type="button" class="badge_item badge_item-min badge_item-g1" (click)="deleteAttachFile(item)">삭제하기</button>
                      </div>
                  </dd>
              </div>
              <div class="tb_tr" *ngIf="isEditable && contentCategoryList && contentCategoryList.length > 0">
                  <dt>카테고리</dt>
                  <dd>
                      <div class="select">
                          <select class="select_current" [(ngModel)]="content.contentCategoryNo">
                              <option *ngFor="let item of contentCategoryList" value="{{item.contentCategoryNo}}">{{item.contentCategoryName}}</option>
                          </select>
                      </div>
                  </dd>
              </div>
              <div class="tb_tr" *ngIf="!isEditable && masterId == 'QNA'">
                  <dt>카테고리</dt>
                  <dd>{{content.contentCategoryName}}</dd>
              </div>
              <div class="tb_tr">
                  <dt>제목</dt>
                  <dd>
                      <div class="form" *ngIf="isEditable">
                          <input type="text" placeholder="제목을 입력해 주세요.(최대 40자)" class="form_input w-full" [(ngModel)]="content.title" />
                      </div>
                      <div class="form" *ngIf="!isEditable">{{content.title}}</div>
                  </dd>
              </div>
              <div class="tb_tr">
                  <dt>내용</dt>
                  <dd>
                    <textarea *ngIf="isEditable" [(ngModel)]="content.description"></textarea>
                    <pre *ngIf="!isEditable">{{content.description}}</pre>
                  </dd>
              </div>
              <ng-container *ngIf="masterId == 'QNA' && isAdmin">
                  <div class="tb_tr">
                      <dt>처리상태</dt>
                      <dd>
                        <div class="select">
                            <select class="select_current" [(ngModel)]="content.processStatus">
                                <option value="REG">등록</option>
                                <option value="COM">처리완료</option>
                                <option value="ING">처리중</option>
                            </select>
                        </div>
                        &nbsp;
                        <button type="button" class="btn_item btn-success" (click)="updateContent()">처리상태 변경</button>
                      </dd>
                  </div>
                  <div class="tb_tr" *ngFor="let item of content.answers">
                    <dt>관리자 답변</dt>
                    <dd>
                        <div>
                            <b>{{item.userName}}({{item.regDate | defaultDate}})</b>
                            &nbsp;
                        <button type="button" class="btn_item btn-danger" (click)="removeContentAnswer(item)">삭제</button>
                        </div>
                        <div class="textarea w-full" style="padding-left: 10px;">
                            <textarea class="brd_none" readonly>{{item.answer}}</textarea>
                        </div>
                    </dd>
                  </div>
              </ng-container>
              <ng-container *ngIf="masterId == 'QNA' && !isAdmin">
                <div class="tb_tr">
                    <dt>처리상태</dt>
                    <dd>{{content.processStatusName}}</dd>
                </div>
                <div class="tb_tr" *ngFor="let item of content.answers">
                    <dt>관리자 답변</dt>
                    <dd>
                        <div>
                            <b>{{item.regDate | defaultDate}}</b>
                        </div>
                        <div class="textarea w-full" style="padding-left: 10px;">
                            <textarea class="brd_none" readonly>{{item.answer}}</textarea>
                        </div>
                    </dd>
                  </div>
              </ng-container>
          </dl>
      </div>
      <br>
      <div class="table-col" *ngIf="masterId == 'QNA' && isAdmin && content.contentAnswerYn != 'Y'">
        <dl class="table">
            <div class="tb_tr">
                <dt>관리자 답변</dt>
                <dd>
                    <div class="textarea w-full">
                        <textarea [(ngModel)]="answer" placeholder="답변을 입력해 주세요."></textarea>
                    </div>
                </dd>
            </div>
        </dl>
      </div>
  </div>

  <div class="table_btn">
      <button type="button" class="btn-default" (click)="windowClose()">닫기</button>
      <button type="button" *ngIf="isAdmin && masterId == 'QNA' && content.contentAnswerYn != 'Y'" class="btn-success" (click)="addContentAnswer()"><b>답변 등록하기</b></button>
      <button type="button" *ngIf="isEditable" class="btn-success" (click)="updateContent()"><b>{{contentMaster.contentMasterName}} 수정하기</b></button>
  </div>
</div>
